module.exports = __webpack_public_path__ + "assets/img/00048.d27965e5.png";